module.exports = __webpack_public_path__ + "static/media/BACHELOR.14c6f30c.pdf";